import { doc, getDoc } from "firebase/firestore";
import { db } from "../Utils/firebase";
import { retrieve } from "../helpers/StorageHelper";

export const getUserFromStorage = () => {
  let user = retrieve("userData");
  return user;
};

export const getUserProfileById = async (userId) => {
  try {
    const userRef = doc(db, "users", userId);
    const userSnap = await getDoc(userRef);
    if (userSnap.exists()) {
      return userSnap.data();
    } else {
      console.warn("User not found:", userId);
      return null;
    }
  } catch (error) {
    console.error("Error fetching user profile:", error);
    return null;
  }
};

export const formatTime = (time) => {
  if (!time) return "";

  try {
    let date;

    // Check if time is Firestore timestamp object
    if (typeof time === "object" && time.seconds !== undefined) {
      date = new Date(time.seconds * 1000 + (time.nanoseconds || 0) / 1e6);
    } else {
      date = new Date(time);
    }

    if (isNaN(date)) return "";

    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-based
    const yy = String(date.getFullYear()); // last two digits of year

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // convert 0 → 12
    const hh = String(hours).padStart(2, "0");

    return `${dd}/${mm}/${yy} ${hh}:${minutes} ${ampm}`;
  } catch (e) {
    return "";
  }
};
